import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import quizReducer from '../reducers';
import { routerMiddleware } from 'react-router-redux';

/* Debug off
import DevTools from '../containers/DevTools';
*/
const initial={};
// https://github.com/reactjs/react-router-redux/issues/305
export default function configureStore( history, initialState=initial) {
let devTools = []
/* Debug off  
  if (typeof document !== 'undefined') {
    devTools = [ DevTools.instrument() ]
  }
*/ 
  const middleware = routerMiddleware(history)
  const store = createStore(
    quizReducer, // already combined
    initialState,
    applyMiddleware(
      thunk,
      middleware
    ),
    ...devTools
  )

/* 170525 0951AM
  const store = createStore(
    quizReducer,
    initialState,    
    compose(
      applyMiddleware(
        thunk,routerMiddleware(history)
      ),
      ...devTools
    )
  )
*/
  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js